export enum eClientIntent {
  certification = 'certification',
  purchase = 'purchase',
  acquisition = 'acquisition',
  resale = 'resale',
}
